<template>
  <div>
    <div v-if="$mq === 'lg' || $mq === 'md'">
      <!--   PC用   -->
      <manager-main-lg></manager-main-lg>
    </div>
    <div v-if="$mq === 'sm'">
      <!--   モバイル用   -->
      <manager-main-sm></manager-main-sm>
    </div>
  </div>
</template>

<script>
import ManagerMainLg from './ManagerMainLg'
import ManagerMainSm from './ManagerMainSm'
export default {
  name: 'ManagerMain',
  components: {
    ManagerMainLg,
    ManagerMainSm
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
:root {
  --outline-color: black
}
</style>



// WEBPACK FOOTER //
// src/components/ManagerMain.vue